import { useState, useEffect } from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import axios from "axios"
import BentoCard from "../BentoCard"
import DetailsModal from "../DetailsModal"
import ExecutiveSummary from "../../ExecutiveSummary"
import { neumorph } from "../neumorph"
import { usePeriod } from "../PeriodContext"
import { formatCurrency } from "../KpiHeader"

const TopStoresCard = ({ supplier, retailer }) => {
  const { startDate, endDate } = usePeriod()
  const [loading, setLoading] = useState(false)
  const [items, setItems] = useState([])
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (!supplier || !retailer) return
    const controller = new AbortController()
    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/insights/executive-summary`,
          { supplier, retailer, userid: localStorage.getItem("userid"), startDate, endDate },
          { signal: controller.signal }
        )
        if (res.data?.status === 1) setItems(res.data.data?.topStores || [])
        else setItems([])
      } catch (err) {
        if (!axios.isCancel(err)) console.error("TopStoresCard fetch error:", err)
      } finally {
        // a cancelled request (retailer / supplier switched) must not end the NEW request\'s loading state
        if (!controller.signal.aborted) setLoading(false)
      }
    }
    fetchData()
    return () => controller.abort()
  }, [supplier, retailer, startDate, endDate])

  return (
    <>
      <BentoCard
        title="🏪 Top 10 Stores"
        subtitle="By revenue this period"
        loading={loading}
        onDetails={() => setModalOpen(true)}
      >
        {items.length === 0 ? (
          <Text fontSize="xs" color={neumorph.textMuted}>
            No data
          </Text>
        ) : (
          <Box>
            {items.map((r, i) => (
              <Flex
                key={r.site_code || i}
                py={1.5}
                borderBottom={i < items.length - 1 ? "1px solid rgba(174,184,200,0.15)" : "none"}
                align="center"
                gap={2}
              >
                <Text fontSize="xs" color={neumorph.textMuted} minW="14px" fontWeight="700">
                  {i + 1}
                </Text>
                <Text fontSize="xs" color={neumorph.textPrimary} flex="1" isTruncated>
                  {r.site_description}
                </Text>
                <Text fontSize="xs" fontWeight="700" color={neumorph.accentGreen}>
                  {formatCurrency(r.total_amount)}
                </Text>
              </Flex>
            ))}
          </Box>
        )}
      </BentoCard>
      <DetailsModal isOpen={modalOpen} onClose={() => setModalOpen(false)} title="Executive Summary">
        <ExecutiveSummary supplier={supplier} retailer={retailer} />
      </DetailsModal>
    </>
  )
}

export default TopStoresCard
